import {CtaWithPattern} from '@miro-site/components_cta-with-pattern'
import {FAQ} from '@miro-site/components_faq'
import {Hero} from '@miro-site/components_hero'
import {HeroFirstLevel} from '@miro-site/components_hero-first-level'
import {HeroSecondLevel} from '@miro-site/components_hero-second-level'
import {RelatedContent} from '@miro-site/components_related-content'
import {TextBlockWithScrollingItems} from '@miro-site/components_text-block-with-scrolling-items'
import {OneColumnEmbed} from '@miro-site/components_one-column-embed'
import {Resources} from '@miro-site/components_resources'
import {Testimonial} from '@miro-site/components_testimonial'
import {AcquisitionHeader} from '@miro-site/components_acquisition-header'
import {AcquisitionFooter} from '@miro-site/components_acquisition-footer'

export * from '@miro-site/components_cta-with-pattern'
export * from '@miro-site/components_faq'
export * from '@miro-site/components_hero'
export * from '@miro-site/components_hero-first-level'
export * from '@miro-site/components_hero-second-level'
export * from '@miro-site/components_related-content'
export * from '@miro-site/components_text-block-with-scrolling-items'
export * from '@miro-site/components_one-column-embed'
export * from '@miro-site/components_resources'
export * from '@miro-site/components_testimonial'
export * from '@miro-site/components_acquisition-header'
export * from '@miro-site/components_acquisition-footer'

export const components = {
  CtaWithPattern,
  FAQ,
  Hero,
  HeroFirstLevel,
  HeroSecondLevel,
  RelatedContent,
  TextBlockWithScrollingItems,
  OneColumnEmbed,
  Resources,
  Testimonial,
  AcquisitionHeader,
  AcquisitionFooter,
}
